import Vue from "vue"
import LoadingPlus from "@/components/loading-plus"
Vue.use(LoadingPlus)

import { Button, Form, FormItem, Dropdown, DropdownMenu,
  DropdownItem, Breadcrumb, BreadcrumbItem, Scrollbar, Menu,
  MenuItem, Submenu, Loading,
  Tooltip,
  Input,
  Select,
  Option,
  OptionGroup,
  DatePicker,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Switch,
  Link,
  ColorPicker,
  Cascader,
  Tag,
  Radio,
  RadioGroup,
  Upload,
  Tree,
  InputNumber,
  TimePicker,
  TimeSelect,
  Card,
  Descriptions,
  DescriptionsItem,
  Result,
  Image,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Row,
  Col,
  RadioButton,
  Autocomplete,
  Tabs,
  TabPane,
  Alert,
  ButtonGroup
} from "element-ui"
Vue.use(Button).use(Form).use(FormItem).use(Dropdown).use(DropdownMenu).use(DropdownItem)
  .use(Breadcrumb).use(BreadcrumbItem).use(Scrollbar).use(Menu).use(MenuItem).use(Submenu)
  .use(Loading).use(Tooltip).use(Input).use(Select).use(Option).use(OptionGroup).use(DatePicker)
  .use(Table).use(TableColumn).use(Pagination).use(Dialog).use(Switch).use(Link)
  .use(ColorPicker).use(Cascader).use(Tag).use(Radio).use(RadioGroup).use(Upload).use(Tree).use(InputNumber)
  .use(TimePicker).use(TimeSelect).use(Card).use(Descriptions).use(DescriptionsItem).use(Result).use(Image)
  .use(Checkbox).use(CheckboxButton).use(CheckboxGroup).use(Row).use(Col).use(RadioButton).use(Autocomplete)
  .use(Tabs).use(TabPane).use(Alert).use(ButtonGroup)
